import BaseModel from './BaseModel';

class HeadUser extends BaseModel {
  constructor(data = {}, api_data = false) {
    super(data);
    if(api_data) {
      this.setApiData(data);
    } else {
      this.updateData(data)
    }
  }

  detailsComponentData = (data) => {
    let base_obj =  {
      id: data.id,
      name: data.name,
      email: data.email,
      mobile_number: data.mobile_number,
      users_types: data.users_types.map((type)=> type.role_name),
    }
    if(data.branch_name != undefined) base_obj['branch'] = data.branch_name
    return base_obj
  }

  setApiData = (data) => {
    this.id = data.id;
    this.name = data.name;
    this.email = data.email;
    this.mobile_number = data.mobile_number;
    this.employee_id = data.employee_id || "";
    this.users_types = data.users_types || [];
    this.profiles = data.profiles || [];
    if(data.branch) {
      this.branch_id = data.branch.id || null
      this.branch_name = data.branch.name || null
    }
    this.zones = data.zones;
    this.circles = data.circles;
    this.clusters = data.clusters;
    this.user_roles = data.user_roles || []
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name;
    this.email = data.email;
    this.mobile_number = data.mobile_number;
    this.employee_id = data.employee_id || "";
    this.profiles = data.profiles || [];
    this.users_types = data.users_types || [];
    this.branch_id = data.branch_id || null;
    this.branch_name = data.branch_name || null
    this.user_roles = data.user_roles || []
    this.users_types = data.users_types || []
    this.zones = data.zones || [];
    this.circles = data.circles || [];
    this.clusters = data.clusters || [];
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      user: {
        name: this.name,
        email: this.email,
        mobile_number: this.mobile_number,
        employee_id: this.employee_id,
        user_roles_attributes: this.user_roles,
        profiles: this.profiles,
        branch_id: this.branch_id
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field].trim() === "") {
          this.errors.name = "This field is required and cannot be empty.";
        }
        else if(this[field].search(/^[a-zA-Z\s'-]+$/) === -1){
          this.errors.name = "Please enter a name using only letters.";
        } else {
          delete this.errors.name;
        }
      },
      email: () => {
        if(this[field].trim() === "") {
          this.errors.email = "This field is required and cannot be empty.";
        }
        else if(this[field].search(/^.+\@.{3,}\..{2,}$/) === -1) {
          this.errors.email ="Invalid email format."
        } else{
          delete this.errors.email;
        }
      },
      mobile_number: () => {
        if(this[field].trim() === "") {
          this.errors.mobile_number = "This field is required and cannot be empty.";
        }
        else if(this[field].search(/^\d{10}$/) === -1) {
          this.errors.mobile_number = "Invalid mobile number format."
        } else {
          delete this.errors.mobile_number;
        }
      },
      employee_id: () => {
        if(this[field] == "") {
          this.errors.employee_id = "Employee id in mandatroy"
        } else{
          delete this.errors.employee_id;
        }
      },
      profiles: () => {
        if (this.head_user_type === "area_head" && this.profiles.length === 0) {
          this.errors.profiles = "Please select profile type.";
        } else {
          delete this.errors.profiles;
        }
      },
      user_roles: () => {
        if (this.user_roles.filter(role=> role?._destroy == false || role?._destroy == undefined).length == 0) {
          this.errors.user_roles = "Please select any user type.";
        } else {
          delete this.errors.user_roles;
        }
      },
      branch_id: () => {
        if(this.user_roles.filter((role)=> role?._destroy == false || role?._destroy == undefined && (role.users_type_id == 1 || role.users_type_id == 25)).length != 0){
          if (this.branch_id == null) {
            this.errors.branch_id = "Branch is compulsory for Area Head and FSO.";
          } else {
            delete this.errors.branch_id;
          }
        } else {
          delete this.errors.branch_id;
        }         
      },

    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default HeadUser;
